export default {
  MODULE: {
    APPOINTMENT: {
      ...makeModuleEvents('Appointment'),
      RESCHEDULED: 'Rescheduled: Appointment',
      ETA_CHANGED: 'Updated: ETA'
    }
  },
  ACTION: {
    BOOK_APPOINTMENT_CLICKED: makeActionEvent('Book Appointment Button Clicked'),
    LOAD_TYPE_SELECTED: makeActionEvent('Load Type Selected'),
    DATE_TIME_SELECTED: makeActionEvent('Date & Time Selected'),
    APPOINTMENT_CREATED: makeActionEvent('Appointment Created'),
    COPIED_APPOINTMENT_ID: makeActionEvent('Appointment ID Copied')
  },
  VIEW: {
    WAREHOUSE: {
      PAGE: makeViewEvent('Warehouse Page')
    },
    MY_APPOINTMENTS_PAGE: makeViewEvent('My Appointments Page')
  }
};

function makeViewEvent(event) {
  return `Viewed: ${event}`;
}

function makeActionEvent(event) {
  return `Action: ${event}`;
}

function makeModuleEvents(moduleName) {
  return {
    CREATED: `Created: ${moduleName}`,
    UPDATED: `Updated: ${moduleName}`,
    DELETED: `Deleted: ${moduleName}`
  };
}
